import { useState } from 'preact/hooks';
import { photoSources } from '../lib/photos';

type Props = {
  /** Base name of a photograph derived by `scripts/photos.mjs`. */
  name: string;
  alt: string;
  /** The `sizes` hint. Without one the browser assumes full-width and overfetches. */
  sizes: string;
  /** 3:2 instead of the default 4:5. */
  wide?: boolean;
  loading?: 'lazy' | 'eager';
};

/**
 * A framed photograph. If the file is missing an engraved swell on the sea
 * gradient stands in, so a bad path degrades to that rather than to a broken
 * image icon.
 */
export function Plate({ name, alt, sizes, wide = false, loading = 'lazy' }: Props) {
  const [failed, setFailed] = useState(false);
  const photo = photoSources(name);
  return (
    <div class={`plate ${wide ? 'plate--wide' : ''}`}>
      {failed ? (
        <svg class="plate__mark" viewBox="0 0 200 120" fill="none" aria-hidden="true">
          {[0, 1, 2].map((i) => (
            <path
              key={i}
              d={`M10 ${52 + i * 16} q 22.5 -10 45 0 t 45 0 t 45 0 t 45 0`}
              stroke="currentColor"
              stroke-width="0.8"
              opacity={0.5 - i * 0.13}
            />
          ))}
        </svg>
      ) : (
        <picture>
          <source type="image/webp" srcset={photo.webp} sizes={sizes} />
          <img
            src={photo.src}
            srcset={photo.jpeg}
            sizes={sizes}
            alt={alt}
            loading={loading}
            decoding="async"
            onError={() => setFailed(true)}
          />
        </picture>
      )}
    </div>
  );
}
